var _path, _g, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _circle3, _path7, _circle4, _circle5, _circle6, _circle7, _circle8, _path8, _g2, _path9, _circle9, _path0, _path1, _circle0, _path10, _circle1, _ellipse, _path11, _circle10, _circle11, _circle12, _circle13, _circle14, _path12, _path13, _rect, _rect2, _path14, _rect3, _rect4, _path15, _rect5, _rect6, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 232,
    viewBox: "0 0 441 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.345 139.129C363.81 135.457 363.546 131.729 362.57 128.158C361.594 124.587 359.924 121.243 357.656 118.318C355.387 115.393 352.565 112.943 349.35 111.108C346.135 109.273 342.59 108.09 338.917 107.625C335.245 107.16 331.517 107.424 327.946 108.4C324.375 109.376 321.031 111.046 318.106 113.314C315.181 115.583 312.731 118.405 310.896 121.62C309.061 124.835 307.878 128.38 307.413 132.053C306.948 135.725 307.212 139.453 308.188 143.024C309.164 146.595 310.834 149.939 313.102 152.864C315.371 155.789 318.193 158.239 321.408 160.074C324.623 161.909 328.168 163.092 331.841 163.557C335.513 164.022 339.241 163.758 342.812 162.782C346.383 161.806 349.727 160.136 352.652 157.868C355.577 155.599 358.027 152.777 359.862 149.562C361.697 146.347 362.88 142.802 363.345 139.129L363.345 139.129Z",
    stroke: "#A7C7E6",
    strokeWidth: 5.12394,
    strokeDasharray: "0.22 2.19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_5004_16829)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335.502,
    cy: 135.675,
    r: 16.9749,
    transform: "rotate(-90 335.502 135.675)",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.97 136.692L337.745 101.63",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.729 139.851L295.981 164.846",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.254 142.184L366.921 179.47",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370.4,
    cy: 178.618,
    r: 11.5083,
    transform: "rotate(137.921 370.4 178.618)",
    fill: "#A7C7E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88 137.995L397.62 139.173",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.366,
    cy: 137.138,
    r: 11.5083,
    transform: "rotate(90 401.366 137.138)",
    fill: "#A7C7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.513 128.239L300.133 71.836",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.892,
    cy: 65.4267,
    r: 11.5083,
    transform: "rotate(-30 295.892 65.4267)",
    fill: "#A7C7E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.964 136.394L262.238 141.94",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.573,
    cy: 142.629,
    r: 11.5083,
    transform: "rotate(-96.6753 261.573 142.629)",
    fill: "#A7C7E6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.502,
    cy: 135.675,
    r: 11.9772,
    transform: "rotate(-90 335.502 135.675)",
    fill: "#DADFE5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.565,
    cy: 135.673,
    r: 8.51748,
    transform: "rotate(-90 335.565 135.673)",
    fill: "white",
    stroke: "#468CD2",
    strokeWidth: 0.683191
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.055,
    cy: 88.7969,
    r: 13.272,
    transform: "rotate(120 340.055 88.7969)",
    fill: "#A7C7E6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.712,
    cy: 166.197,
    r: 13.272,
    transform: "rotate(107.247 292.712 166.197)",
    fill: "#A7C7E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.083 131.808C137.548 128.135 137.284 124.407 136.308 120.837C135.332 117.266 133.662 113.922 131.394 110.997C129.125 108.071 126.303 105.621 123.088 103.787C119.873 101.952 116.328 100.768 112.655 100.304C108.983 99.8392 105.255 100.102 101.684 101.079C98.113 102.055 94.7694 103.725 91.844 105.993C88.9186 108.261 86.4686 111.084 84.6339 114.299C82.7992 117.514 81.6157 121.059 81.1511 124.732C80.6864 128.404 80.9497 132.132 81.9259 135.703C82.902 139.274 84.5719 142.617 86.8402 145.543C89.1085 148.468 91.9309 150.918 95.146 152.753C98.3612 154.588 101.906 155.771 105.579 156.236C109.251 156.7 112.979 156.437 116.55 155.461C120.121 154.485 123.465 152.815 126.39 150.547C129.315 148.278 131.765 145.456 133.6 142.241C135.435 139.026 136.618 135.48 137.083 131.808L137.083 131.808Z",
    stroke: "#A7C7E6",
    strokeWidth: 5.12394,
    strokeDasharray: "0.22 2.19"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddddd_5004_16829)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.345,
    cy: 128.502,
    r: 16.9749,
    transform: "rotate(-90 109.345 128.502)",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.744 127.394L103.969 162.456",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.036,
    cy: 162.93,
    r: 6.7687,
    transform: "rotate(180 104.036 162.93)",
    fill: "#A7C7E6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.628 130.304L64.6635 158.066",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M103.053 126.621L64.304 99.9639",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5938,
    cy: 100.082,
    r: 8.45296,
    transform: "rotate(-60 64.5938 100.082)",
    fill: "#A7C7E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 136.49L138.622 183.114",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.101,
    cy: 182.263,
    r: 11.5083,
    transform: "rotate(137.921 142.101 182.263)",
    fill: "#A7C7E6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.769,
    cy: 77.1071,
    rx: 10.9875,
    ry: 10.7586,
    transform: "rotate(90 199.769 77.1071)",
    fill: "#A7C7E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.248 116.688L89.6854 47.5015",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.2054,
    cy: 46.7682,
    r: 11.5083,
    transform: "rotate(-14.9116 89.2054 46.7682)",
    fill: "#A7C7E6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.345,
    cy: 128.501,
    r: 11.9772,
    transform: "rotate(-90 109.345 128.501)",
    fill: "#DADFE5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.408,
    cy: 128.499,
    r: 8.17588,
    transform: "rotate(-90 109.408 128.499)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.6097,
    cy: 156.649,
    r: 13.272,
    transform: "rotate(107.247 64.6097 156.649)",
    fill: "#A7C7E6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.39,
    cy: 128.543,
    r: 8.39977,
    stroke: "#468CD2",
    strokeWidth: 0.683191
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.756 80.7659L114.675 120.926",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M210.081 80.4248L322.808 134.055",
    stroke: "#C3D4E6",
    strokeWidth: 0.683191
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 403.17,
    y: 141.662,
    width: 19.6584,
    height: 17.6584,
    rx: 1.19558,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 403.17,
    y: 141.662,
    width: 19.6584,
    height: 17.6584,
    rx: 1.19558,
    stroke: "#DAE6F2",
    strokeWidth: 0.341596
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M409.234 154.991C408.464 154.991 407.983 154.156 408.369 153.49L412.134 146.986C412.519 146.32 413.48 146.32 413.865 146.986L417.63 153.49C418.016 154.156 417.535 154.991 416.765 154.991L409.234 154.991ZM413.052 153.528C413.159 153.528 413.247 153.492 413.318 153.42C413.389 153.347 413.425 153.258 413.425 153.151C413.425 153.044 413.388 152.955 413.316 152.884C413.244 152.814 413.154 152.778 413.047 152.778C412.94 152.778 412.852 152.814 412.781 152.887C412.71 152.959 412.675 153.049 412.675 153.155C412.675 153.262 412.711 153.351 412.783 153.422C412.855 153.493 412.945 153.528 413.052 153.528ZM412.675 151.766C412.675 151.973 412.842 152.141 413.05 152.141C413.257 152.141 413.425 151.973 413.425 151.766L413.425 149.716C413.425 149.509 413.257 149.341 413.05 149.341C412.842 149.341 412.675 149.509 412.675 149.716L412.675 151.766Z",
    fill: "#F89C9D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.17,
    y: 54.6615,
    width: 19.6584,
    height: 17.6584,
    rx: 1.19558,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201.17,
    y: 54.6615,
    width: 19.6584,
    height: 17.6584,
    rx: 1.19558,
    stroke: "#DAE6F2",
    strokeWidth: 0.341596
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M207.234 67.9907C206.464 67.9907 205.983 67.1564 206.369 66.4897L210.134 59.9855C210.519 59.3203 211.48 59.3203 211.865 59.9855L215.63 66.4897C216.016 67.1564 215.535 67.9907 214.765 67.9907L207.234 67.9907ZM211.052 66.5282C211.159 66.5282 211.247 66.4921 211.318 66.4198C211.389 66.3475 211.425 66.2579 211.425 66.151C211.425 66.0442 211.388 65.9553 211.316 65.8845C211.244 65.8136 211.154 65.7782 211.047 65.7782C210.94 65.7782 210.852 65.8144 210.781 65.8867C210.71 65.959 210.675 66.0485 210.675 66.1554C210.675 66.2623 210.711 66.3511 210.783 66.422C210.855 66.4928 210.945 66.5282 211.052 66.5282ZM210.675 64.7657C210.675 64.9728 210.842 65.1407 211.05 65.1407C211.257 65.1407 211.425 64.9728 211.425 64.7657L211.425 62.7157C211.425 62.5086 211.257 62.3407 211.05 62.3407C210.842 62.3407 210.675 62.5086 210.675 62.7157L210.675 64.7657Z",
    fill: "#F89C9D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1703,
    y: 150.451,
    width: 19.6584,
    height: 19.1838,
    rx: 1.19558,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1703,
    y: 150.451,
    width: 19.6584,
    height: 19.1838,
    rx: 1.19558,
    stroke: "#DAE6F2",
    strokeWidth: 0.341596
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.234 164.542C29.4636 164.542 28.9826 163.708 29.3685 163.041L33.1341 156.537C33.5193 155.872 34.4798 155.872 34.8649 156.537L38.6305 163.041C39.0165 163.708 38.5354 164.542 37.7651 164.542L30.234 164.542ZM34.0517 163.08C34.1586 163.08 34.2474 163.044 34.3183 162.972C34.3891 162.899 34.4245 162.81 34.4245 162.703C34.4245 162.596 34.3884 162.507 34.3161 162.436C34.2438 162.365 34.1542 162.33 34.0473 162.33C33.9404 162.33 33.8516 162.366 33.7808 162.438C33.7099 162.511 33.6745 162.6 33.6745 162.707C33.6745 162.814 33.7107 162.903 33.7829 162.974C33.8552 163.045 33.9448 163.08 34.0517 163.08ZM33.6745 161.317C33.6745 161.525 33.8424 161.692 34.0495 161.692C34.2566 161.692 34.4245 161.525 34.4245 161.317L34.4245 159.267C34.4245 159.06 34.2566 158.892 34.0495 158.892C33.8424 158.892 33.6745 159.06 33.6745 159.267L33.6745 161.317Z",
    fill: "#F89C9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_5004_16829",
    x: 291.199,
    y: 118.7,
    width: 88.605,
    height: 95.4369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.945283
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.378113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.27165
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.908658
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5004_16829",
    result: "effect2_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.27731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71092
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5004_16829",
    result: "effect3_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.62999
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.05199
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5004_16829",
    result: "effect4_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.2711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.70842
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_5004_16829",
    result: "effect5_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.1596
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.6638
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_5004_16829",
    result: "effect6_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_5004_16829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddddd_5004_16829",
    x: 65.0427,
    y: 111.527,
    width: 88.605,
    height: 95.4369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.945283
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.378113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.27165
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.908658
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5004_16829",
    result: "effect2_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.27731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71092
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5004_16829",
    result: "effect3_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.62999
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.05199
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5004_16829",
    result: "effect4_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.2711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.70842
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_5004_16829",
    result: "effect5_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.1596
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.6638
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_5004_16829",
    result: "effect6_dropShadow_5004_16829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_5004_16829",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/LoginBG.54521617929caac027e9ef3ba08c2cd8.svg";
export { ForwardRef as ReactComponent };